<template>
    <div id="incidentrecord">
        <div class="zhegai">
            <h3 id="today">今日事件总数</h3>
            <div id="record">
                <h2 :class="today == 0 ? 'backColor' : 'redColor'">{{ today }}</h2>
                <div class="pack" @click="ToName">
                    查看报警分析 <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </div>
        <div class="kong"></div>
        <div class="timer" v-if="today > 0">
            <div class="headline">
                <div class="timer-title">
                    {{ latest.name }}<span v-if="latest.deviceName ">-</span>{{latest.type}}
                </div>
                <!-- <div >{{timerapp(timeNow)}}</div> -->
                <div class="timer-time">{{ timeNow | diff }}</div>
            </div>

            <div id="article">
                <p id="description">{{ latest.type }}</p>
                <el-button type="text" @click="showDetail(latest.code)">详情
                </el-button>
                <Details v-if="isShowDetail" :dialogVisible="isShowDetail" :status="accidentDetailStatus"
                    :detail="detail" @closeDetail="closeDetail" />
            </div>
        </div>

        <!-- //如果等于空 -->
        <div class="timer" v-else>
            <div class="totaynone">今日暂无事件</div>
        </div>
    </div>
</template>
<script>
    import {
        chainIndex
    } from "../../../api/linkindex";
    //详情
    import Details from "../../../components/accidentManagement/Details";
    import {
        GetAccidentDetailForId,
        GetAccidentValue,

    } from "../../../api/accident";
    //时间
    // import "../../../util/time";
    import dateTimeStamp from "../../../util/DateDiff";
    export default {
        data() {
            return {  all: '',
                today: "",
                timeNow: 0, //时间
                oImgect: 0, //图片显示隐藏
                hour: "", //详情
                isShowDetail: false,
                accidentDetailStatus: "loaded",
                detail: null,
                timer: null,
            };
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        components: {
            Details,
        },
        filters: {
            diff: function (value) {
                // console.log(value,dateTimeStamp(value))
                return dateTimeStamp(value);
            },
        },
        //   watch: {
        //     timeNow(n, o) {
        //     //   console.log(n, o);
        //       this.timeNow = n;
        //     },
        //     today(n, o) {
        //       this.today = n;
        //     },
        //   },
        computed: {
                fengji: function () {

                if (this.$store.state.project.currentProject.projectId == 4) {
                    return "Temperature_status_windopen"
                    //  console.log(value)
                } else {
                    return "Fan_Status"
                    //  console.log(value)
                }
            },
            latest() {
                var recordTime = Date.parse(this.$store.getters.latest.start); //记录时间
                this.timeNow = recordTime;

                return this.$store.getters.latest;
            },
            img: function () {
                return IMAGE[this.data.classify];
            },
        },
        mounted() {
            this.timer = setInterval(() => {
                // console.log('触发刷新');
                this.$forceUpdate();
            }, 60000);
            this.todayTotol();
        },
        methods: {
            async showDetail(code) {
                // console.log(code);
                this.accidentDetailStatus = 'loading';
                this.isShowDetail = true;
                this.detail = await this.getAccidentDetail(code);
                // console.log(this.detail,'cc');
                if (this.detail == null) {
                    this.accidentDetailStatus = 'error';
                }
                // console.log(this.detail);
                this.accidentDetailStatus = 'loaded';
                // 标记事件已读
                !this.data.isRead && this.setIsRead(code) && this.$store.commit('setNotifycationIsRead', code);;
            },
            closeDetail() {
                this.isShowDetail = false;
            },

            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 && status !== true) {
                    console.error("response error: code is not 200 or status is not true");
                    return null;
                }
                return data;
            },
           accidentDetailMapper(data) {
                return {
                    loopId: data.loop_id,
                    img: data.device_img,
                    name: data.loop_name,
                    deviceName: data.device_name,
                    position: data.area_name,
                    code: data.id,
                    classify: data.alarm_event_type,
                    type: data.alarm_type_desc,
                    start: data.start_time,
                    end: data.end_time,
                    description: data.alarm_type_desc,
                    node: data.node,
                    check: data.alarm_check,
                    realName: data.real_name,
                    event_name: data.event_name,
                    device: data.device_details,
                    loop_type:data.loop_type
                }
            },
            accidentValueMapper(data, node,type) {
                let snapshot = data.results[0].series;
                if (snapshot == undefined) {
                    return []
                }
                let temps = snapshot.map((item) => {
                    //   console.log(item)
                    return [item.tags.node, item.values[0][1]];
                });
                let map = new Map(temps);
                //console.log(map);
                return this.accidentValueFormat(map, node,type);
            },
              accidentValueFormat(map, node,type) {
                // console.log(node)
               if(type.classify=='TELEMETRY_OVERRUN'&&type.loop_type=='TRANSFORMER'){
                    return [{
                            title: '温度',
                            unit: '℃',
                            isDangerous: ['Temperature_A', 'Temperature_B', 'Temperature_C'].includes(node),
                            value: [{
                                    name: 'A',
                                    value: map.get('Temperature_A')?map.get('Temperature_A').toFixed(2):map.get('Temperature_A'),
                                    isDangerous: ['Temperature_A'].includes(node),
                                },
                                {
                                    name: 'B',
                                    value: map.get('Temperature_B')?map.get('Temperature_B').toFixed(2):map.get('Temperature_B'),
                                    isDangerous: ['Temperature_B'].includes(node),
                                },
                                {
                                    name: 'C',
                                    value: map.get('Temperature_C')?map.get('Temperature_C').toFixed(2):map.get('Temperature_C'),
                                    isDangerous: ['Temperature_C'].includes(node),
                                },
                                // {name: '均', value: map.get('Vvavg')},
                            ]
                        }, {
                            title: '风机状态',

                            isDangerous: [this.fengji].includes(node),

                            value: [{
                                isDangerous: [this.fengji].includes(node),
                                value: map.get(this.fengji)
                            }]
                        },  {
                            title: '负载',
                            unit: 'V',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: ['P'].includes(node),
                                value: (map.get('P') / 1000).toFixed(2)
                            }, ]
                        }, {
                            title: '负载率',
                            unit: '%',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),
                                value: map.get(this.fengji)?map.get(this.fengji).toFixed(2):map.get(this.fengji)
                            }, ]
                        },
                        {
                            title: '容量',
                            unit: 'kVA',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),

                            }, ]
                        }
                    ]   
                }else{
                    return [{
                        title: '三相相电压',
                        unit: 'V',
                        isDangerous: ['Ua', 'Ub', 'Uc', 'Vvavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ua')?map.get('Ua').toFixed(2):map.get('Ua')
                            },
                            {
                                name: 'B',
                                value: map.get('Ub')?map.get('Ub').toFixed(2):map.get('Ub')
                            },
                            {
                                name: 'C',
                                value: map.get('Uc')?map.get('Uc').toFixed(2):map.get('Uc')
                            },
                            // {name: '均', value: map.get('Vvavg')},
                        ]
                    }, {
                        title: '三相线电压',
                        unit: 'V',
                        isDangerous: ['Uab', 'Ubc', 'Uac', 'Vlavg'].includes(node),
                        value: [{
                                name: 'AB',
                                value: map.get('Uab')?map.get('Uab').toFixed(2):map.get('Uab')
                            },
                            {
                                name: 'BC',
                                value: map.get('Ubc')?map.get('Ubc').toFixed(2):map.get('Ubc')
                            },
                            {
                                name: 'AC',
                                value: map.get('Uac')?map.get('Uac').toFixed(2):map.get('Uac')
                            },
                            // {name: '均', value: map.get('Vlavg')},
                        ]
                    }, {
                        title: '电流',
                        unit: 'A',
                        isDangerous: ['Ia', 'Ib', 'Ic', 'Iavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ia')?map.get('Ia').toFixed(2):map.get('Ia')
                            },
                            {
                                name: 'B',
                                value: map.get('Ib')?map.get('Ib').toFixed(2):map.get('Ib')
                            },
                            {
                                name: 'C',
                                value: map.get('Ic')?map.get('Ic').toFixed(2):map.get('Ic')
                            },
                            // {name: '均', value: map.get('Iavg')},
                        ]
                    }, {
                        title: '有功功率',
                        unit: 'W',
                        isDangerous: ['Pa', 'Pb', 'Pc', 'P'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Pa')?map.get('Pa').toFixed(2):map.get('Pa')
                            },
                            {
                                name: 'B',
                                value: map.get('Pb')?map.get('Pb').toFixed(2):map.get('Pb')
                            },
                            {
                                name: 'C',
                                value: map.get('Pc')?map.get('Pc').toFixed(2):map.get('Pc')
                            },
                            // {name: '总', value: map.get('PA')}
                        ]
                    }, {
                        title: '无功功率',
                        unit: 'W',
                        isDangerous: ['PRa', 'PRb', 'PRc', 'PR'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PRa')?map.get('PRa').toFixed(2):map.get('PRa')
                            },
                            {
                                name: 'B',
                                value: map.get('PRb')?map.get('PRb').toFixed(2):map.get('PRb')
                            },
                            {
                                name: 'C',
                                value: map.get('PRc')?map.get('PRc').toFixed(2):map.get('PRc')
                            },
                            // {name: '总', value: map.get('PR')},
                        ]
                    }, {
                        title: '温度',
                        unit: '℃',
                        isDangerous: ['Temperature'].includes(node),
                        value: [{
                            name: 'T',
                            value: map.get('Temperature')
                        }, ]
                    }, {
                        title: '频率',
                        unit: 'Hz',
                        isDangerous: ['F'].includes(node),
                        value: [{
                            name: 'F',
                            value: map.get('F')
                        }, ]
                    }]
                }
              
                },
            async getAccidentDetail(id) {
                let result = await Promise.all([
                    GetAccidentDetailForId(id),
                    GetAccidentValue(id),
                ]);
                let result0 = this.transformForData(result[0]);
                let result1 = this.transformForData(result[1]);
                //   console.log(result0, result1)

                if (result0.details === null || result1.snapshot === null) {
                    return;
                }
                  result0.details = this.accidentDetailMapper(result0.details)
                result1.snapshot = this.accidentValueMapper(result1.snapshot, result0.details.node,result0.details).filter((
                    item) => {
                    let obj = JSON.parse(result0.details.device)

                    if (item.title == '风机状态') {
                        if (item.value[0].value == 0) {
                            item.value[0].value = '关闭'

                        } else if (item.value[0].value > 0) {
                            item.value[0].value = '开启'
                        }
                    } else if (item.title == '负载') {

                        if (fzl == 0 || rl == 0) {
                            this.all = 0
                        } else {
                            var fzl = item.value[0].value
                            var rl = obj.电气.容量.split('k')
                            // console.log(fzl, rl[0])
                            this.all = fzl / rl[0]
                        }
                        // console.log(this.all)
                    } else if (item.title == '容量') {
                        item.value[0].value = obj.电气.容量.split('kVA')[0]
                    } else if (item.title == '负载率') {
                        // console.log(this.all)
                        item.value[0].value = this.all
                    }


                    return item
                });

                // console.log(result0.details, result1.snapshot)
                return {
                    infomation: result0.details,
                    data: result1.snapshot
                };
            },
            ToName() {
                this.$router.push("accident-analysis");
            }, //今日事件总数 ID
            todayTotol() {
                this.id = this.$store.state.project.currentProject.projectId;
                chainIndex.warnAll(0, this.id).then((res) => {
                    this.today = res.data.data.num;
                    // console.log(res.data.data.num);
                });
            },
        },
    };
</script>
<style lang="less" scoped>
    #incidentrecord {
        .w(528);
        .h(320);
        background: #fff;

        .zhegai {
            background-color: #fff;
            .h(150);
        }

        #today {
            padding: 23rem 64rem 0 24rem;
            color: #333333;
            font-size: 16rem;
        }

        #record {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10rem 24px 0rem 24rem;

            .backColor {
                color: black;
                font-size: 36px;
            }

            .redColor {
                color: red;
                font-size: 36px;
            }

            .pack {
                font-size: 16rem;
                color: #999999;
                margin: 10rem 0 0 0;
                cursor: pointer;
            }

            .pack:hover {
                color: #0d94ff;
            }
        }

        .kong {
            .h(1);
            .w(528);

            background: rgba(0, 0, 0, 0.06; );
            // opacity: 0.06;
        }

        .timer {
            padding: 32rem 32rem 0 25rem;
            background: rgba(0, 0, 0, 0.02);
            height: 100%;

            .totaynone {
                font-size: 18rem;
                font-weight: 400;
                color: #333333;
                padding: 19rem 0 0 25rem;
                // background-color: red;
            }

            .headline {
                display: flex;
                justify-content: space-between;

                // background-color: red;
                .timer-title {
                    font-size: 18rem;
                    color: #333333;
                    margin-bottom: 10rem;
                    // background-color: red;
                }

                .timer-time {
                    font-size: 16rem;
                    color: #999999;
                }
            }

            #article {
                // background-color: red;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-right: 23rem;

                // margin-top: 20rem;
                #description {
                    font-size: 16rem;
                    color: #999999;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
</style>